module.exports = __webpack_public_path__ + "img/shop-photo6.e3b7359f.jpg";